import {
  CheckCircleTwoTone,
  DollarTwoTone,
  LikeTwoTone,
} from '@ant-design/icons'
import { Space } from 'antd'
import React from 'react'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'
import { accents } from 'sutra/tokens/colors'
import { colorToHex } from 'sutra/utils/color'

import LayersSvgIcon from 'components/post-overview/LayersSvgIcon'

// antd's `@ant-design/colors` palette generator (what TwoTone icons use
// internally to derive the light fill from `twoToneColor`) can't parse an
// oklch() string — it silently returns black. Convert the Sutra tokens to
// hex first, same fix as App.tsx's ConfigProvider theme.
const RECOMMENDED_COLOR = colorToHex(accents.violetHorizon[500])
const VERIFIED_COLOR = colorToHex(accents.reflectionBlue[500])
const PROMOTED_COLOR = colorToHex(accents.emeraldAura[500])

export const PostIcons: React.FC<{
  is_verified: boolean
  is_recommended: boolean
  is_promoted: boolean
  n_instances?: number
  spacing?: number
  onPromoHover?: (isHover: boolean) => void
}> = (props) => {
  return (
    <Space size={props.spacing}>
      {props.is_recommended && (
        <Tooltip content="Recommended">
          <LikeTwoTone twoToneColor={RECOMMENDED_COLOR} />
        </Tooltip>
      )}
      {props.is_verified && (
        <Tooltip content="Verified">
          <CheckCircleTwoTone twoToneColor={VERIFIED_COLOR} />
        </Tooltip>
      )}
      {props.is_promoted && (
        <Tooltip content="Promotional">
          <DollarTwoTone
            twoToneColor={PROMOTED_COLOR}
            onMouseEnter={() => props.onPromoHover?.(true)}
            onMouseLeave={() => props.onPromoHover?.(false)}
            style={{
              fontSize: '16px',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          />
        </Tooltip>
      )}
      {props.n_instances && props.n_instances > 1 && (
        <Tooltip
          content={`${props.n_instances} duplicate posts across variants`}
        >
          <span style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
            <LayersSvgIcon size={16} color="#9CA3AF" />
          </span>
        </Tooltip>
      )}
    </Space>
  )
}
